import Message from './Message';
import MessageOk from './MessageOk';

export default Message;
export { MessageOk };
